const isActionEmpty = (text) => {
  if (!text || text === '<p class="md-block-unstyled"><br/></p>') {
    return true;
  }
  return false;
};

export default isActionEmpty;
